import queryString from 'query-string';

import { postJson } from 'utils/http/postJson';

import type { ApiListingApplicationListingType } from './types/ApiListingApplicationListingType';

export type RequestedAttachmentPayload =
  | {
      type: 'FILE';
      s3FileId: string;
    }
  | {
      type: 'URL';
      url: string;
    }
  | {
      type: 'TEXT';
      text: string;
    };

export type ListingApplicationPayload = {
  id: string;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  email: string | null | undefined;
  requestedAttachments: RequestedAttachmentPayload[];
  requestedAttachmentsHash: string;
  resumeS3FileId?: string;
  replaceCurrentResume?: boolean;
  type: ApiListingApplicationListingType;
  consentAts?: boolean;
};

export type NonAtsListingApplicationPayload = {
  id: string;
  requestedAttachmentsHash: string;
  type: ApiListingApplicationListingType;
};

export async function validateApplication(
  payload: Record<string, unknown>,
  params?: {
    partial: boolean;
  },
): Promise<{
  listingApplication: ListingApplicationPayload;
}> {
  const qs = params ? queryString.stringify(params) : null;
  return postJson(
    `/data/listing-applications-validation${qs ? `?${qs}` : ''}`,
    payload,
  );
}
